module.exports = __webpack_public_path__ + "img/taller_rosario.8508d4aa.jpg";